// M12 - ReviMotricityApi
//
// Cliente para los endpoints /api/v1/revi/motricity/* que gestionan
// la telemetria de juegos VR externos (vrbuzzwire y futuros).

import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class ReviMotricityApi {
  constructor() {
    this.baseApi = ENV.BASE_API;
    this.route = "revi/motricity";
  }

  // POST /link - vincula un codigo a una sesion activa + paciente
  async linkCode(
    token,
    { code, gameKey, activeSessionId, patientId, sceneIndex },
  ) {
    const url = `${this.baseApi}/${this.route}/link`;
    return this._fetch(url, {
      method: "POST",
      headers: { ...cabecerasApi(token), "Content-Type": "application/json" },
      body: JSON.stringify({
        code,
        gameKey,
        activeSessionId,
        patientId,
        sceneIndex,
      }),
    });
  }

  // GET /sessions/by-active/:id - codigos vinculados a una sesion activa
  async listByActiveSession(token, activeSessionId) {
    const url = `${this.baseApi}/${this.route}/sessions/by-active/${activeSessionId}`;
    return this._fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  // GET /sessions - listado con filtros (para tab paciente, dashboard)
  async listSessions(token, query = {}) {
    const qs = new URLSearchParams();
    Object.entries(query).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const url = `${this.baseApi}/${this.route}/sessions${qs.toString() ? `?${qs.toString()}` : ""}`;
    return this._fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  // GET /sessions/:id - detalle completo
  async getSession(token, id) {
    const url = `${this.baseApi}/${this.route}/sessions/${id}`;
    return this._fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  /**
   * POST /sessions/:id/summary — parrafo clinico redactado por IA.
   *
   * POST y no GET aunque parezca una lectura: la primera vez produce una
   * llamada a un modelo de pago. Con un GET, un prefetch del navegador pagaria
   * resumenes que nadie ha pedido.
   *
   * El idioma va en `Accept-Language`, que ya inyecta `cabecerasApi`. El texto
   * se redacta directamente en cada idioma, no se traduce despues: traducir un
   * texto clinico a posteriori es otra oportunidad de que cambie el sentido.
   */
  async getSessionSummary(token, id) {
    const url = `${this.baseApi}/${this.route}/sessions/${id}/summary`;
    return this._fetch(url, {
      method: "POST",
      headers: cabecerasApi(token),
    });
  }

  // M12.1 - GET /games - catalogo de juegos VR enabled.
  // Sustituye al array hardcodeado del linker y al listSupportedGames()
  // del registry estatico. La fuente de verdad es la coleccion Mongo
  // gestionada desde /admin/revi?tab=motricity-games.
  async listEnabledGames(token) {
    const url = `${this.baseApi}/${this.route}/games`;
    return this._fetch(url, {
      method: "GET",
      headers: cabecerasApi(token),
    });
  }

  async _fetch(url, params) {
    const response = await fetch(url, params);
    let json = null;
    try {
      json = await response.json();
    } catch (e) {
      json = null;
    }
    if (response.status >= 200 && response.status < 300) return json;
    const err = new Error(json?.message || `HTTP ${response.status}`);
    err.status = response.status;
    err.body = json;
    throw err;
  }
}
